import { useAsync } from "./useAsync";
import * as api from "../lib/api";
import type { Database } from "../lib/database.types";

type HomepageVideoRow = Database["public"]["Tables"]["homepage_videos"]["Row"];

const HOMEPAGE_VIDEOS_CACHE_KEY = "bollyrhythm.homepageVideos.v2";

function readCachedHomepageVideos(): HomepageVideoRow[] | undefined {
  if (typeof window === "undefined") return undefined;

  try {
    const cached = window.localStorage.getItem(HOMEPAGE_VIDEOS_CACHE_KEY);
    if (!cached) return undefined;

    const parsed = JSON.parse(cached);
    return Array.isArray(parsed) ? parsed : undefined;
  } catch {
    return undefined;
  }
}

function cacheHomepageVideos(videos: HomepageVideoRow[] | null) {
  if (typeof window === "undefined" || !videos?.length) return;

  try {
    window.localStorage.setItem(HOMEPAGE_VIDEOS_CACHE_KEY, JSON.stringify(videos));
  } catch {
    // Ignore unavailable/full localStorage; videos still load from Supabase.
  }
}

/** Fetch homepage video slots. */
export function useHomepageVideos() {
  return useAsync(
    async () => {
      const result = await api.getHomepageVideos();
      cacheHomepageVideos(result.data as HomepageVideoRow[] | null);
      return result;
    },
    [],
    { initialData: readCachedHomepageVideos() },
  );
}
